/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 *
 * App.js
 * JS and SASS sourcepoint for Vite compiler.
 *
 * @author John Pobojewski <https://john.pobojewski.com>
 * @since 2.0.0
 * @see vite.app.js
 */

// CSS

import "/src/styles/main.scss";

// Components

import FormLock from "/src/scripts/components/FormLock.js";
import FormSelect from "/src/scripts/components/FormSelect.js";
import TextEditor from "/src/scripts/components/TextEditor.js";
import EntryHeroImage from "/src/scripts/components/EntryHeroImage.js";
import EntryAssets from "/src/scripts/components/EntryAssets.js";
import EntryCredits from "/src/scripts/components/EntryCredits.js";
import EntryDelete from "/src/scripts/components/EntryDelete.js";
import EntryJudging from "/src/scripts/components/EntryJudging.js";
import Modal from "/src/scripts/components/Modal.js";
import CheckboxToggleData from "/src/scripts/components/CheckboxToggleData.js";
import SelectToggleData from "/src/scripts/components/SelectToggleData.js";
import NavToggleView from "/src/scripts/components/NavToggleView.js";
import ScrollCue from "/src/scripts/components/ScrollCue.js";
import HostedVideo from "/src/scripts/components/HostedVideo.js";
import Gallery from "/src/scripts/components/Gallery.js";
import AutoCompleteField from "/src/scripts/components/AutoCompleteField.js";
import Certificate from "/src/scripts/components/Certificate.js";

// Overall

NavToggleView.init();

// Don't init ScrollCue on certificate pages
if (!window.location.href.includes("/certificate")) {
  ScrollCue.init();
}

// Homepage

if (document.body.classList.contains("homepage")) {
  Gallery.init();
}

// Account

if (window.location.href.match("account/set-studio")) {
  AutoCompleteField.init();
  TextEditor.init("#studio-bio", "#studio-bio-textarea");
}

if (window.location.href.match("account")) {
  AutoCompleteField.init();
  EntryDelete.init();
  Modal.init();
}

// Studio edit page

if (window.location.href.includes("/studios/edit")) {
  TextEditor.init("#studio-bio", "#studio-bio-textarea");
}

// Entries edit pages

if (window.location.href.includes("/entries/edit")) {
  var pathArray = window.location.pathname.split("/");
  Modal.init();

  switch (pathArray[3]) {
    case "assets":
      EntryHeroImage.init();
      EntryAssets.init();
      document
        .querySelector(".g-recaptcha")
        .addEventListener("click", function () {
          Modal.processing("Uploading...");
        });
      break;

    case "credits":
      EntryCredits.init();
      break;

    default:
      TextEditor.init("#description-textbox", "#description");
      break;
  }
}

// Entries pages

if (document.body.classList.contains("entries")) {
  SelectToggleData.init("judgesChoiceSelect", "fields[judgesChoice]", "array");
  Modal.init();
}

// Entry page

if (document.body.classList.contains("entry")) {
  if (document.body.classList.contains("judging")) {
    CheckboxToggleData.init("voteToggle", "fields[votes]", "array");

    if (document.body.classList.contains("admin")) {
      CheckboxToggleData.init(
        "honorableMention",
        "fields[honorableMention]",
        "toggle",
      );
      EntryJudging.init(false);
    } else {
      EntryJudging.init(true);
    }

    Modal.init();
  }
  HostedVideo.init();
}

// Judges

if (
  document.body.classList.contains("judges") ||
  document.body.classList.contains("judge")
) {
  HostedVideo.init();
}

// Certificate

if (window.location.href.includes("/certificate")) {
  Certificate.init();
}
